export const messages = {
    "en": {
        waiting: 'Waiting...',

        homePage_title: 'Integrated information system «BSUIR: University»',
        homePage_details: 'Detailed information about automated systems operating within the IIS «BSUIR: University» can be found at the following',
        homePage_link: 'link',
        homePage_aboutUs: 'About us',
        homePage_technicalSupportTitle: 'Technical support',
        homePage_technicalSupportMessage: 'Our team will help in case of problems',
        homePage_contactUs: 'Contact us',
        homePage_phonebookTitle: 'Phonebook',
        homePage_phonebookMessage: 'University staff contact details',
        homePage_followLink: 'Follow',
        homePage_documentationTitle: 'Documentation',
        homePage_documentationMessage: 'IIS system API for third-party services',

        navigationHeader_title: 'IIS «BSUIR: University»',
        navigationHeader_signIn: 'Sign In',
        navigationHeader_bugReport: 'Report a bug',
        
        sidebar_schedules: 'Schedules',
        sidebar_scheduleGroup: 'Group schedule',
        sidebar_scheduleEmployee: 'Educator schedule',
        sidebar_scheduleDepartment: 'Department schedule',
        sidebar_departments: 'Departments',
        sidebar_students: 'Students',
        sidebar_rating: 'Rating',
        sidebar_listOfDisciplines: 'List of disciplines',
        sidebar_phonebook: 'Phonebook',

        phonebook_title: 'Phonebook',
        phonebook_referenceInformation: 'Reference PBX of the University:',
        phonebook_table_phone: 'Phone number',
        phonebook_table_room: 'Placement',
        phonebook_table_department: 'Department',
        phonebook_table_employees: 'Employees',
        phonebook_table_note: 'Note',

        listOfDisciplines_title: 'List of studied disciplines of BSUIR specialties',
        listOfDisciplines_selector_year: 'Year',
        listOfDisciplines_selector_faculty: 'Faculty',
        listOfDisciplines_selector_educationForm: 'Education form',
        listOfDisciplines_selector_speciality: 'Speciality',
        listOfDisciplines_discipline: 'Discipline',
        listOfDisciplines_hours: 'Hours',

        rating_title: 'Rating of BSUIR students',
        rating_selector_year: 'Year',
        rating_selector_faculty: 'Faculty',
        rating_selector_speciality: 'Speciality',
        rating_selector_studentCardNumber: 'Search by № stud. card',
        rating_table_studentCardNumber: 'Student card №',
        rating_table_total: 'Total',
        rating_table_averageMark: 'Average mark',
        rating_table_hours: 'Hours',
        rating_table_hoursNote: 'Hours issed for illegal reasons',
        rating_table_controlPoint: 'CP',
        rating_table_subject: 'Subject',
        rating_table_marks: 'Marks',
        rating_table_outOfCP: 'Out of CP',
        rating_table_piece: 'pc.',
        rating_table_hoursShort: 'h.',
        rating_table_noMarks: 'none',

        studentsListFilter_lastName: 'Start typing last name',
        studentsListFilter_faculty: 'Faculty',
        studentsListFilter_course: 'Course',
        studentsListFilter_selectSkill: 'Pick a skill',
        studentsListFilter_searchJob: 'Searching for a job',
        studentsListFilter_searchButton: 'Search',
        studentsListFilter_resetButton: 'Reset',

        departmentsList_title: 'Main departments of BSUIR',
        departmentsList_search: 'Search...',
        departmentsList_emptySearchResults: 'No matches found.',

        employeePersonCard_degree: 'Academic degree',
        employeePersonCard_placement: 'Workplace',
        employeePersonCard_jobPosition: 'position',
        employeePersonCard_contacts: 'Contacts',
        employeePersonCard_contacts_email: 'Email',
        employeePersonCard_contacts_phone: 'Work phone',
        employeePersonCard_profileLinks: 'Profile links',

        departmentSchedule_title: 'Department schedule',
        departmentSchedule_placeholder: 'Department',
        departmentSchedule_date: 'Date',
        departmentSchedule_announcement: 'Announcement',
        departmentSchedule_educator: 'Educator',
        departmentSchedule_download: 'Download department schedule',
        departmentSchedule_noAnnouncements: 'There are no announcements',     
        
        employeeSchedule_title: 'Educator schedule',
        employeeSchedule_fioPlaceholder: 'Please enter last name...',
        employeeSchedule_dispatcherPhone: 'Dispatcher',
        employeeSchedule_lessonsStartDate: 'Lessons start date',
        employeeSchedule_lessonsEndDate: 'Lessons end date',
        employeeSchedule_sessionStartDate: 'Examinations start date',
        employeeSchedule_sessionEndDate: 'Examinations end date',
        employeeSchedule_tooltip_personalInformation: 'Personal information',
        employeeSchedule_tooltip_downloadSchedule: 'Download schedule Excel',
        employeeSchedule_tooltip_googleCalendar: 'Google calendar import',
        employeeSchedule_tabs_lessons: 'Lessons',
        employeeSchedule_tabs_session: 'Examinations',
        employeeSchedule_filters_title: 'Filters',
        employeeSchedule_filters_week: 'week ',
        employeeSchedule_filters_weeks: 'Weeks ',
        employeeSchedule_filters_week_current: 'now it is ',
        employeeSchedule_filters_week_current2: 'current',
        employeeSchedule_filters_week_all: 'all',
        employeeSchedule_filters_subgroups: 'Subgroups',
        employeeSchedule_noLessons: 'No lesson',

        groupSchedule_title: 'Group schedule',
        groupSchedule_groupNumberPlaceholder: 'Please enter group number...',
        groupSchedule_dispatcherPhone: 'Dispatcher',
        groupSchedule_lessonsStartDate: 'Lessons start date',
        groupSchedule_lessonsEndDate: 'Lessons end date',
        groupSchedule_sessionStartDate: 'Examinations start date',
        groupSchedule_sessionEndDate: 'Examinations end date',
        groupSchedule_tooltip_downloadSchedule: 'Download schedule Excel',
        groupSchedule_tooltip_googleCalendar: 'Google calendar import',
        groupSchedule_tabs_lessons: 'Lessons',
        groupSchedule_tabs_session: 'Examinations',
        groupSchedule_filters_title: 'Filters',
        groupSchedule_filters_week: 'week ',
        groupSchedule_filters_weeks: 'Weeks ',
        groupSchedule_filters_week_current: 'now it is ',
        groupSchedule_filters_week_current2: 'current',
        groupSchedule_filters_week_all: 'all',
        groupSchedule_filters_subgroups: 'Subgroups',
        groupSchedule_noLessons: 'No lesson',
        groupSchedule_noGroup: 'Attention! Group not found.',

        announcements_title: 'Announcements',
        announcements_empty: 'There are no announcements',

        footer_support: 'Technical support',
        footer_rightsReserved: 'All rights reserved.',
        footer_developers: 'ITD CIIE BSUIR',
        footer_bsuir: 'EE "Belarusian State University of Informatics and Radioelectronics"',
        footer_tin: 'TIN'
    },
    "ru": {
        waiting: 'Ожидание ввода...',

        homePage_title: 'Интегрированная информационная система «БГУИР: Университет»',
        homePage_details: 'С более подробной информацией об автоматизированных системах, функционирующих в рамках ИИС «БГУИР: Университет» можно ознакомиться по следующей',
        homePage_link: 'ссылке',
        homePage_aboutUs: 'О нас',
        homePage_technicalSupportTitle: 'Техподдержка',
        homePage_technicalSupportMessage: 'Наша команда поможет при возникновении проблем',
        homePage_contactUs: 'Свяжитесь с нами',
        homePage_phonebookTitle: 'Телефонный справочник',
        homePage_phonebookMessage: 'Контактные данные сотрудников университета',
        homePage_followLink: 'Перейти',
        homePage_documentationTitle: 'Документация',
        homePage_documentationMessage: 'API системы ИИС для сторонних сервисов',

        navigationHeader_title: 'ИИС «БГУИР: Университет»',
        navigationHeader_signIn: 'Войти',
        navigationHeader_bugReport: 'Сообщить об ошибке',

        sidebar_schedules: 'Расписания',
        sidebar_scheduleGroup: 'Расписание группы',
        sidebar_scheduleEmployee: 'Расписание преподавателя',
        sidebar_scheduleDepartment: 'Расписание кафедры',
        sidebar_departments: 'Подразделения',
        sidebar_students: 'Студенты',
        sidebar_rating: 'Рейтинг',
        sidebar_listOfDisciplines: 'Перечень дисциплин',
        sidebar_phonebook: 'Телефонный справочник',

        phonebook_title: 'Телефонный справочник',
        phonebook_referenceInformation: 'Справочная АТС университета:',
        phonebook_table_phone: 'Номер телефона',
        phonebook_table_room: 'Помещение',
        phonebook_table_department: 'Подразделение',
        phonebook_table_employees: 'Сотрудники',
        phonebook_table_note: 'Примечания',

        listOfDisciplines_title: 'Перечень изучаемых дисциплин специальностей БГУИР',
        listOfDisciplines_selector_year: 'Год',
        listOfDisciplines_selector_faculty: 'Факультет',
        listOfDisciplines_selector_educationForm: 'Форма обучения',
        listOfDisciplines_selector_speciality: 'Специальность',
        listOfDisciplines_discipline: 'Дисциплина',
        listOfDisciplines_hours: 'Часы',

        rating_title: 'Рейтинг студентов БГУИР',
        rating_selector_year: 'Год',
        rating_selector_faculty: 'Факультет',
        rating_selector_speciality: 'Специальность',
        rating_selector_studentCardNumber: 'Поиск по № студ. билета',
        rating_table_studentCardNumber: '№ студ. билета',
        rating_table_total: 'Итого',
        rating_table_averageMark: 'Ср. оценка',
        rating_table_hours: 'Часы',
        rating_table_hoursNote: 'Часы, пропущенные по неуважительной причине',
        rating_table_controlPoint: 'КТ',
        rating_table_subject: 'Предмет',
        rating_table_marks: 'Оценки',
        rating_table_outOfCP: 'Вне КТ',
        rating_table_piece: 'шт.',
        rating_table_hoursShort: 'ч.',
        rating_table_noMarks: 'отсутствуют',

        studentsListFilter_lastName: 'Начните вводить фамилию',
        studentsListFilter_faculty: 'Факультет',
        studentsListFilter_course: 'Курс',
        studentsListFilter_selectSkill: 'Выберите навык',
        studentsListFilter_searchJob: 'В поисках работы',
        studentsListFilter_searchButton: 'Поиск',
        studentsListFilter_resetButton: 'Сбросить',

        departmentsList_title: 'Основные подразделения БГУИР',
        departmentsList_search: 'Поиск...',
        departmentsList_emptySearchResults: 'По данному запросу ничего не найдено.',

        employeePersonCard_degree: 'Ученая степень:',
        employeePersonCard_placement: 'Место работы',
        employeePersonCard_jobPosition: 'должность',
        employeePersonCard_contacts: 'Контакты',
        employeePersonCard_contacts_email: 'Почта',
        employeePersonCard_contacts_phone: 'Рабочий телефон',
        employeePersonCard_profileLinks: 'Ссылки на профили',

        departmentSchedule_title: 'Расписание кафедры',
        departmentSchedule_placeholder: 'Кафедра',
        departmentSchedule_date: 'Дата',
        departmentSchedule_announcement: 'Объявление',
        departmentSchedule_educator: 'Преподаватель',
        departmentSchedule_download: 'Загрузить расписание кафедры',
        departmentSchedule_noAnnouncements: 'Объявлений нет',
        
        employeeSchedule_title: 'Расписание занятий для преподавателей',
        employeeSchedule_fioPlaceholder: 'Введите ФИО преподавателя...',
        employeeSchedule_dispatcherPhone: 'Тел. диспетчера',
        employeeSchedule_lessonsStartDate: 'Начало занятий',
        employeeSchedule_lessonsEndDate: 'Конец занятий',
        employeeSchedule_sessionStartDate: 'Начало сессии',
        employeeSchedule_sessionEndDate: 'Конец сессии',
        employeeSchedule_tooltip_personalInformation: 'Персональная информация',
        employeeSchedule_tooltip_downloadSchedule: 'Скачать расписание Excel',
        employeeSchedule_tooltip_googleCalendar: 'Импорт Google календаря',
        employeeSchedule_tabs_lessons: 'Занятия',
        employeeSchedule_tabs_session: 'Сессия',
        employeeSchedule_filters_title: 'Фильтры',
        employeeSchedule_filters_week: 'неделя ',
        employeeSchedule_filters_weeks: 'Недели ',
        employeeSchedule_filters_week_current: 'сейчас ',
        employeeSchedule_filters_week_current2: 'текущая',
        employeeSchedule_filters_week_all: 'все',
        employeeSchedule_filters_subgroups: 'Подгруппы',
        employeeSchedule_noLessons: 'Занятий нет',

        groupSchedule_title: 'Расписание занятий для студентов БГУИР',
        groupSchedule_groupNumberPlaceholder: 'Введите номер группы...',
        groupSchedule_dispatcherPhone: 'Тел. диспетчера',
        groupSchedule_lessonsStartDate: 'Начало занятий',
        groupSchedule_lessonsEndDate: 'Конец занятий',
        groupSchedule_sessionStartDate: 'Начало сессии',
        groupSchedule_sessionEndDate: 'Конец сессии',
        groupSchedule_tooltip_downloadSchedule: 'Скачать расписание Excel',
        groupSchedule_tooltip_googleCalendar: 'Импорт Google календаря',
        groupSchedule_tabs_lessons: 'Занятия',
        groupSchedule_tabs_session: 'Сессия',
        groupSchedule_filters_title: 'Фильтры',
        groupSchedule_filters_week: 'неделя ',
        groupSchedule_filters_weeks: 'Недели ',
        groupSchedule_filters_week_current: 'сейчас ',
        groupSchedule_filters_week_current2: 'текущая',
        groupSchedule_filters_week_all: 'все',
        groupSchedule_filters_subgroups: 'Подгруппы',
        groupSchedule_noLessons: 'Занятий нет',
        groupSchedule_noGroup: 'Внимание! Группа не найдена.',

        announcements_title: 'Объявления',
        announcements_empty: 'Объявлений нет',

        footer_support: 'Техподдержка',
        footer_rightsReserved: 'Все права защищены.',
        footer_developers: 'ОИТ ЦИИР БГУИР',
        footer_bsuir: 'УО "Белорусский государственный университет информатики и радиоэлектроники"',
        footer_tin: 'УНН'
    }
}